import * as React from 'react';

import {SectionLabel} from 'shells/typography/section-label';

import {FileList} from './file-list';
import {uploadFiles} from './upload-files';

import styles from './file-section.module.css';

type Props = {
    model: any;
};

export class FileSection extends React.Component<Props> {
    render() {
        return (
            <div className={styles['file-section']}>
                <SectionLabel>Attached files</SectionLabel>
                <button onClick={this.handleUploadFiles} className={styles['file-upload-button']}>
                    Upload file
                </button>
                <FileList files={this.props.model.getFiles()} />
            </div>
        );
    }

    handleUploadFiles = () => {
        uploadFiles(this.props.model);
    };
}
